import { useMutation } from "@apollo/client";
import {
  Button,
  Grid,
  LoadingOverlay,
  NumberInput,
  Select,
  Stack,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { CREATE_DISCOUNT, UPDATE_DISCOUNT } from "apollo/mutuations";
import { PRODUCT_DISCOUNT } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import { useEffect } from "react";
import { formatLocalDate } from "utiles/url";

export const DiscountUpdateModal = ({ productDiscount, id, setOpened }) => {
  const { height } = useViewportSize();
  const [updateProductDiscount, { loading, error }] =
    useMutation(UPDATE_DISCOUNT);

  const form = useForm({
    initialValues: {
      discount_value_type: "PERCENTAGE",
      discount_value: 0,
      start_date: null,
      end_date: null,
    },
    validate: {
      discount_value_type: (value) =>
        value ? null : "Discount type is required",
      discount_value: (value) =>
        value > 0 ? null : "Discount value must be greater than 0",
      start_date: (value) => (value ? null : "Start date is required"),
    },
  });
  useEffect(() => {
    if (productDiscount) {
      form.setValues({
        discount_value_type: productDiscount.discount_value_type,
        discount_value: productDiscount.discount_value,
        start_date: productDiscount.start_date
          ? new Date(productDiscount.start_date)
          : null,
        end_date: productDiscount.end_date
          ? new Date(productDiscount.end_date)
          : null,
      });
    }
  }, [productDiscount]);

  const submit = () => {
    updateProductDiscount({
      variables: {
        id: productDiscount.id,
        product_id: form.getInputProps("product_id").value,
        discount_value_type: form.getInputProps("discount_value_type").value,
        discount_value: parseFloat(form.getInputProps("discount_value").value),
        start_date: formatLocalDate(form.getInputProps("start_date").value),
        end_date: form.getInputProps("end_date").value
          ? formatLocalDate(form.getInputProps("end_date").value)
          : null,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Discount Created Successfully",
        });
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Create Discount",
        });
      },
    });
  };

  return (
    <>
      <LoadingOverlay
        visible={loading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <form onSubmit={form.onSubmit(() => submit())}>
        <Stack>
          <Grid>
            <Grid.Col span={4}>
              <Select
                required
                label="Discount Type"
                placeholder="Select discount type"
                data={[
                  { value: "PERCENTAGE", label: "Percentage" },
                  { value: "FLAT", label: "Flat" },
                ]}
                {...form.getInputProps("discount_value_type")}
              />
              <NumberInput
                required
                label="Discount Value"
                placeholder="Enter discount value"
                min={0}
                precision={2}
                {...form.getInputProps("discount_value")}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <DatePicker
                required
                label="Start Date"
                placeholder="Select start date"
                {...form.getInputProps("start_date")}
              />
              <DatePicker
                label="End Date"
                placeholder="Select end date (optional)"
                {...form.getInputProps("end_date")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={4}>
              <Button
                type="submit"
                style={{
                  width: "25%",
                  marginTop: "15px",
                  backgroundColor: "#FF6A00",
                  color: "#FFFFFF",
                }}
                fullWidth
              >
                Submit
              </Button>
            </Grid.Col>
          </Grid>
        </Stack>
      </form>
    </>
  );
};
